import { invert } from 'lodash';

export const ENTITY = {
    CREATIVE: 'CREATIVE',
    DISPLAY: 'DISPLAY',
    NATIVE: 'NATIVE',
};

export const ENTITY_TO_PATH_MAP = {
    [ENTITY.CREATIVE]: 'creative',
    [ENTITY.DISPLAY]: 'display',
    [ENTITY.NATIVE]: 'native',
};

export const PATH_TO_ENTITY_MAP = invert(ENTITY_TO_PATH_MAP);
